export default __webpack_public_path__ + "static/media/5.bb5e95f5.jpg";